const registerMemberToast = (state = null, action) => {
  if (action.type === "SET_REGISTER_MEMBER_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_REGISTER_MEMBER_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default registerMemberToast;
